/**
 * Size guide modal: tables become horizontally scrollable on small viewports
 * (display: block + overflow-x: auto). A scrollable region has to be reachable
 * by keyboard, so mark it focusable and name it while it actually scrolls.
 *
 * The modal body is merchant-authored metaobject rich text, so table captions
 * arrive as `<div class="table-heading h2">`. They sit under the modal's own
 * <h2>, so expose them as level-3 headings.
 */
(() => {
  if (window.dynamicSizeGuideTablesInit) return;
  window.dynamicSizeGuideTablesInit = true;

  const MODAL_SELECTOR = 'basic-modal[id*="PopupModal-dynamic-size-guide"]';

  const promoteHeadings = (modal) => {
    modal.querySelectorAll('.rte .table-heading').forEach((node) => {
      if (/^H[1-6]$/.test(node.tagName) || node.hasAttribute('role')) return;
      node.setAttribute('role', 'heading');
      node.setAttribute('aria-level', '3');
    });
  };

  const tableLabel = (table, modal) => {
    let node = table.previousElementSibling;
    while (node) {
      const headingSelector = 'h1, h2, h3, h4, h5, h6, .table-heading';
      const heading = node.matches(headingSelector) ? node : node.querySelector(headingSelector);
      if (heading) return heading.textContent.trim();
      node = node.previousElementSibling;
    }
    return modal.querySelector('.drawer__body h2')?.textContent.trim() || 'Size guide';
  };

  const updateTables = (modal) => {
    modal.querySelectorAll('.rte table').forEach((table) => {
      if (table.scrollWidth > table.clientWidth) {
        table.setAttribute('tabindex', '0');
        table.setAttribute('role', 'region');
        table.setAttribute('aria-label', tableLabel(table, modal));
      } else {
        table.removeAttribute('tabindex');
        table.removeAttribute('role');
        table.removeAttribute('aria-label');
      }
    });
  };

  document.addEventListener('modal:handleAfterShow', (event) => {
    const modal = event.target.closest?.(MODAL_SELECTOR);
    if (!modal) return;
    promoteHeadings(modal);
    updateTables(modal);
  });

  document.querySelectorAll(MODAL_SELECTOR).forEach(promoteHeadings);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll(`${MODAL_SELECTOR}[open]`).forEach(updateTables);
    }, 150);
  });
})();
